export interface ChangelogEntry {
  version: string
  date: string // YYYY-MM-DD
  current?: boolean
  items: string[]
}

// Newest first. Add a new entry (and bump APP_VERSION in version.ts) whenever a
// meaningful set of changes ships — this is what renders on Settings → ประวัติการเปลี่ยนแปลง.
export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '1.21.5',
    date: '2026-11-02',
    current: true,
    items: [
      'ป้าย QR Code Asset: ปรับเป็นขาวดำแบบเรียบ — แสดงเฉพาะรหัส Asset ตัวใหญ่ ยี่ห้อ/รุ่น และ QR Code',
      'Assets: เลือกหลายรายการแล้วกด "พิมพ์ป้าย QR" ได้ — พิมพ์สติกเกอร์ 1 ดวงต่อ 1 หน้า และกำหนดขนาดสติกเกอร์ (mm) ได้',
    ],
  },
  {
    version: '1.21.4',
    date: '2026-10-20',
    items: [
      'Assets: ปุ่ม "คอลัมน์" — เลือกคอลัมน์ที่จะแสดงในตารางได้ (เช่น IP Address, Serial Number, MAC, ยี่ห้อ/รุ่น, OS/CPU/RAM, หมดประกัน, ราคาซื้อ ฯลฯ) และจัดลำดับคอลัมน์ได้ — บันทึกการตั้งค่าไว้ต่อผู้ใช้อัตโนมัติ คอลัมน์ใหม่เรียงลำดับได้',
    ],
  },
  {
    version: '1.21.3',
    date: '2026-10-20',
    items: [
      'นำเข้า Assets: เพิ่ม "สร้าง Template / กรอกข้อมูล" — เลือกคอลัมน์ที่ต้องการ กรอกข้อมูลเป็นตาราง (ประเภท/สถานะ/หมวดหมู่/ยี่ห้อ/แผนก เลือกจาก Master Data) ทำซ้ำ/ลบแถวได้ แล้วดาวน์โหลดเป็น CSV ตามข้อมูลที่กรอก หรือกดนำเข้าได้ทันที (ข้อมูลที่กรอกค้างไว้ในเบราว์เซอร์)',
      'นำเข้า Assets จาก CSV: หน้าตรวจสอบแสดงข้อมูลครบทุกคอลัมน์ที่จะ import และเลือก Site ได้ (กรองตามบริษัทที่เลือก) — แผนกในไฟล์ที่ชื่อตรงกับแผนกของ Site จะถูกผูกให้อัตโนมัติ',
      'นำเข้า Assets จาก CSV: รองรับประเภท/สถานะที่เพิ่มเองใน Master Data (เดิมจะกลายเป็น OTHER) และคอลัมน์ "รหัสทรัพย์สิน" (Asset Tag)',
      'แก้ไข: กู้คืนข้อมูล (Restore Backup) ล้มเหลวด้วย error relation "CheckStatusSet" does not exist',
    ],
  },
  {
    version: '1.21.2',
    date: '2026-10-15',
    items: [
      'ใบงาน: ลบรูปภาพ / ไฟล์แนบหน้างานได้ (ปุ่มถังขยะท้ายแต่ละไฟล์ — เฉพาะผู้มีสิทธิ์จัดการ Asset และใบงานที่ยังไม่ล็อก)',
    ],
  },
  {
    version: '1.21.1',
    date: '2026-10-13',
    items: [
      'Network Diagram: ใช้รูปภาพแทนไอคอนอุปกรณ์ได้ — เลือกจากรูปของ Asset ที่ผูกไว้หรืออัปโหลดเอง (PNG/JPG/WEBP/GIF ไม่เกิน 5MB), โหมด "เต็มรูป" แสดงรูปตามสัดส่วนจริงไม่มีกรอบ และปุ่ม "ใช้รูปจาก Asset ทั้งหมด"',
      'Network Diagram: ปรับขนาดอุปกรณ์/รูปได้อิสระ — ลากมุมขวาล่างบน Diagram หรือกำหนดความกว้าง (px) ในแผงคุณสมบัติ',
      'Network Diagram: ลากป้าย Port และข้อความบนเส้นเพื่อย้ายตำแหน่งไม่ให้ทับกัน (ดับเบิลคลิกเพื่อคืนตำแหน่งเดิม)',
      'Network Diagram: ปรับรูปเส้นเชื่อมต่อได้ — ลากจุดกลางเพื่อดัดเส้น/ย้ายช่วงกลางของเส้นหักมุม และลากจุดที่ปลายเส้นเพื่อเลื่อนจุดเข้า-ออกตามขอบอุปกรณ์',
    ],
  },
  {
    version: '1.21.0',
    date: '2026-10-09',
    items: [
      'เพิ่มแท็บ "Network Diagram" ในหน้า Assets: วาดผังเครือข่ายแยกตาม Site (มีได้หลาย Diagram ต่อ Site) — ลากวางอุปกรณ์ 23 ประเภท, Zone/กลุ่ม (ปรับขนาด/สี/เส้นขอบ, ลากแล้วอุปกรณ์ข้างในย้ายตาม), ข้อความ, เส้นเชื่อมต่อพร้อม Preset (Ethernet/Fiber/WAN/Trunk/VPN/Wireless/Backup) ปรับสี ความหนา ลายเส้น รูปแบบเส้นทาง หัวลูกศร และข้อความบนเส้น',
      'Network Diagram: ระบุ Port ต้นทาง/ปลายทางของแต่ละเส้นเชื่อม แสดงที่ปลายเส้นทั้งสองด้าน',
      'Network Diagram: ผูกอุปกรณ์กับ Asset ของ Site (แสดงเลข Asset และรุ่น), เพิ่ม Assets ทั้ง Site ลง Diagram อัตโนมัติ, โหมดดู/แก้ไข, Undo/Redo, คัดลอก/วาง, จัดแนว/กระจายระยะ, ค้นหาอุปกรณ์/IP, MiniMap, Export PNG/JSON และ Import JSON',
      'การเข้าถึงเมนู: เพิ่มสิทธิ์ "Network Diagram (แท็บใน Assets)" — แก้ไข Diagram ได้เฉพาะผู้มีสิทธิ์จัดการ Asset',
    ],
  },
  {
    version: '1.20.3',
    date: '2026-10-06',
    items: [
      'ใบงาน: แก้ไขได้ทุกสถานะยกเว้น "ลงนามแล้ว" (เดิมแก้ได้เฉพาะร่าง) — แก้หัวข้อ ลูกค้า สถานที่ Asset วันนัดหมาย รายละเอียด และเปลี่ยนสถานะ (ร่าง / กำลังดำเนินการ / เสร็จงาน / ยกเลิก) ได้จากหน้าต่างแก้ไข รวมถึงเปิดใบงานที่ยกเลิกกลับมาใหม่',
    ],
  },
  {
    version: '1.20.2',
    date: '2026-10-06',
    items: [
      'ใบงาน: ช่อง "รายละเอียดงาน" เปลี่ยนเป็น Rich Text Editor (ตัวหนา, หัวข้อ, รายการ, ตาราง, แทรกรูป/วางรูปด้วย Ctrl+V) และแสดงผลตามรูปแบบที่จัดไว้ทั้งในหน้ารายละเอียดและหน้าพิมพ์',
      'ใบงานสถานะ "ร่าง" แก้ไขได้แล้ว — ปุ่ม "แก้ไข" ในหน้ารายละเอียด แก้หัวข้อ ลูกค้า สถานที่ Asset วันนัดหมาย และรายละเอียดงานได้ (ใบงานสถานะอื่นแก้ไม่ได้)',
    ],
  },
  {
    version: '1.20.1',
    date: '2026-09-22',
    items: [
      'System Check: Host เปิดให้บันทึกผลตรวจของตัวเองได้แล้ว (นอกเหนือจากรายการย่อยข้างใต้) — ติ๊กเปิดที่ "จัดการรายการ → แก้ไข Host" พร้อมเลือก status set เฉพาะ Host นั้น แถวจะกลายเป็นคลิกบันทึกได้เหมือนรายการย่อยและนับรวมใน % ครบถ้วน/Dashboard/Export ด้วย — Host เดิมทั้งหมดยังปิดอยู่ตามค่าเดิม ไม่กระทบข้อมูลย้อนหลัง',
    ],
  },
  {
    version: '1.20.0',
    date: '2026-09-22',
    items: [
      'เพิ่มหน้า System Status (เมนู Admin): สถานะรวมของระบบ, Database, พื้นที่จัดเก็บ (Database/Uploads), จำนวนบริษัท/ผู้ใช้/Asset/Ticket, สถานะ Integrations (Email, Entra ID, SAML, AI Provider, Zabbix, GLPI) และ Scheduled Jobs (User Sync, OneDrive Backup) — รีเฟรชอัตโนมัติทุก 30 วินาที',
      'ปรับผังเมนู: เปลี่ยนชื่อ "Daily Check" เป็น "System Check", ย้าย "การยืม" ไปเป็นแท็บในหน้า Assets และย้าย "รายงาน" ไปเป็นแท็บในหน้า Dashboard (ลิงก์เก่า /bookings และ /reports ยังใช้งานได้ตามปกติ)',
      'หน้า Assets: รวมตัวกรองทั้งหมดมาไว้แถวเดียวและลดขนาดให้กะทัดรัดขึ้น พร้อมเอาตัวกรอง "ทุกยี่ห้อ", "ทุก Vendor", "MA ทั้งหมด", "ประกันทั้งหมด" ออก',
      'Software License: เพิ่มข้อมูลสัญญา/ผู้ขาย — Vendor, เลขที่สัญญา/PO, วันที่ซื้อ, มูลค่าสัญญา, วันเริ่ม/สิ้นสุดสัญญา และต่ออายุอัตโนมัติ พร้อมแสดงในการ์ด License',
      'แก้หน้า ตั้งค่าระบบ → Master Data → Vendor ที่กดเพิ่ม/แก้ไข/ลบไม่ได้ (เรียก API ผิด endpoint) ให้ใช้งานได้ตามปกติ พร้อมข้อความแจ้งเตือนเมื่อผิดพลาด',
    ],
  },
  {
    version: '1.19.0',
    date: '2026-09-21',
    items: [
      'เพิ่มเมนู Daily Check: บันทึกผลตรวจระบบ IT รายวัน/สัปดาห์/เดือน แบบตาราง (heatmap) คลิกช่องเพื่อบันทึก ดู remark และประวัติการแก้ไข',
      'จัดการรายการจาก UI ได้ทั้งหมด: เพิ่ม/แก้/ลบ/ย้าย Group และ Item (2 ระดับ Host → VM), ลากวางเรียงลำดับ, status set แก้ label/สีได้, import Excel/CSV, ทำซ้ำ และคัดลอกโครงสร้าง — ประวัติอ้างอิงด้วย id, ยกเลิกใช้งานแทนการลบเมื่อมีบันทึกแล้ว และทุกการแก้ config ลง audit log',
      'Dashboard ภาพรวม: KPI เทียบเดือนก่อน, trend รายวัน, Top รายการผิดปกติ, Server uptime, Backup success rate, เปรียบเทียบรายเดือน และ Timeline ความผิดปกติต่อเนื่อง พร้อมตัวกรองบริษัท/Group/เดือน/ปี และ export PNG / Excel / PDF',
    ],
  },
  {
    version: '1.18.6',
    date: '2026-09-17',
    items: [
      'หน้าเพิ่ม/แก้ไข Asset: เมื่อบันทึกไม่สำเร็จ (เช่น Asset Code หรือ Serial Number ซ้ำ) จะมี popup เด้งเตือนทันทีให้เห็นชัด นอกเหนือจากข้อความสีแดงเดิม',
      'แก้ข้อความแจ้งเตือนข้อมูลซ้ำตอนบันทึก Asset ที่เคยขึ้นว่า "Serial number ซ้ำในระบบ: null" ผิดพลาด — ตอนนี้จะระบุฟิลด์ที่ซ้ำจริง (Asset Code หรือ Serial Number) พร้อมค่าที่ซ้ำให้ถูกต้อง',
      'แก้ปุ่ม Export ในหน้า Assets ที่เคย export ข้อมูลของทุกบริษัทออกมา (ไม่สนใจบริษัทที่กำลังสวิตช์ดูอยู่) — ตอนนี้จะ export เฉพาะบริษัทที่กำลังดูอยู่เท่านั้น',
      'หน้า Tickets: ปรับดีไซน์ badge สถานะ/ความสำคัญ และแถบสรุปสถิติให้อ่านง่ายขึ้น เปลี่ยน "SLA Breach" ให้คำนวณเป็นรายเดือนปฏิทินแทนย้อนหลัง 30 วัน และค้นหา ticket ได้จากชื่อ/username ผู้แจ้งเพิ่มเติม',
    ],
  },
  {
    version: '1.18.5',
    date: '2026-09-15',
    items: [
      'แก้ Import Asset จาก WinAudit CSV: รองรับรูปแบบไฟล์จริงของ WinAudit (คอลัมน์ ItemOrder,RecordNumber,CategoryID,CategoryName,ItemID,ItemName,ItemValue) — เดิมอ่านคอลัมน์ผิดตำแหน่งทำให้ไม่มีข้อมูลขึ้นมาให้เลย',
      'เปลี่ยนชื่อแท็บ "Import Asset (CSV)" ในหน้าตั้งค่าเป็น "Import Asset" ให้ตรงกับเนื้อหาที่มีทั้ง CSV, WinAudit และ GLPI',
    ],
  },
  {
    version: '1.18.4',
    date: '2026-09-15',
    items: [
      'หน้า Sync จาก GLPI: คำสั่งติดตั้งค้นหาไฟล์ .msi ให้อัตโนมัติทั่วทุก user บนเครื่อง — แก้ปัญหากรณีเปิด PowerShell (Administrator) ด้วยคนละบัญชีกับที่ล็อกอินเดสก์ท็อป/ดาวน์โหลดไฟล์ ทำให้หาไฟล์ไม่เจอ',
    ],
  },
  {
    version: '1.18.3',
    date: '2026-09-15',
    items: [
      'หน้า Sync จาก GLPI: คำสั่งติดตั้งจะ cd ไปที่โฟลเดอร์ Downloads ให้อัตโนมัติก่อนติดตั้ง (กันปัญหาหาไฟล์ .msi ไม่เจอเมื่อรันจากโฟลเดอร์อื่น) และรอให้การติดตั้งเสร็จจริงก่อนสั่งสแกน พร้อมแจ้งเตือนชัดเจนถ้าติดตั้งไม่สำเร็จ',
    ],
  },
  {
    version: '1.18.2',
    date: '2026-09-15',
    items: [
      'หน้า Sync จาก GLPI: แก้คำสั่งติดตั้ง GLPI Agent — เดิมพึ่ง Windows service ให้สแกนทันทีหลังติดตั้ง (RUNNOW=1) แต่บางเครื่องไม่ยอมสแกนให้ ตอนนี้คำสั่งจะสั่งให้ agent สแกนและส่งเข้า GLPI ทันที 1 ครั้งต่อจากการติดตั้งเลย ไม่ต้องรอ service',
    ],
  },
  {
    version: '1.18.1',
    date: '2026-09-14',
    items: [
      'หน้ารายละเอียด Asset: เพิ่มปุ่ม "เปิดใน GLPI" สำหรับ Asset ที่มาจาก GLPI Sync — พาไปหน้ารายละเอียดเครื่องนั้นบน GLPI โดยตรง',
      'หน้า Sync จาก GLPI: เพิ่มปุ่ม "เชื่อม GLPI ID" สำหรับจับคู่ Asset ที่เคย sync จาก GLPI ไว้ก่อนหน้านี้ (ยังไม่มี GLPI ID บันทึกไว้) ด้วย Serial Number ย้อนหลัง',
    ],
  },
  {
    version: '1.18.0',
    date: '2026-09-14',
    items: [
      'นำเข้า Assets: เพิ่มแท็บ "Sync จาก GLPI" — เชื่อมต่อ GLPI Server เพื่อดึงข้อมูล hardware/software (CPU, RAM, Storage, OS, ซอฟต์แวร์ที่ลงไว้) จากเครื่อง PC ที่ลง GLPI Agent มา sync เข้า Asset โดยตรง จับคู่กับ Asset เดิมอัตโนมัติด้วย Serial Number',
      'หน้า Sync จาก GLPI: ดาวน์โหลด GLPI Agent (.msi) พร้อมคำสั่งติดตั้งแบบ silent ที่ใส่ URL เซิร์ฟเวอร์ให้อัตโนมัติ',
      'Asset: แสดงแหล่งที่มาของข้อมูล (GLPI Agent / WinAudit / CSV / กรอกเอง) ทั้งในหน้ารายการและหน้ารายละเอียด',
      'เลขที่ Ticket แยกนับต่อบริษัท (แต่ละบริษัทเริ่มที่ #0001 แทนการนับรวมกันทั้งระบบ)',
      'แก้ไขตัวจับเวลารายงาน Zabbix อัตโนมัติ ไม่ให้รันซ้ำเมื่อการสร้างรายงานใช้เวลานานกว่ารอบตรวจสอบ',
    ],
  },
  {
    version: '1.17.0',
    date: '2026-09-10',
    items: [
      'Auto-Task Rules: มอบหมายเฉพาะ Task ให้ผู้รับผิดชอบเท่านั้น — ไม่ตั้งเป็นผู้รับผิดชอบ (Technician) ของ Ticket และไม่เปลี่ยนสถานะ Ticket',
      'แจ้งเตือนทางอีเมลเมื่อมีการมอบหมาย Task ให้ผู้ใช้ (ทั้งจาก Auto-Task Rules, การเพิ่ม Task เอง และการเปลี่ยนผู้รับผิดชอบ Task)',
      'หน้า ServiceDesk: เพิ่มคอลัมน์ Category ในตาราง',
      'หน้า ServiceDesk: คลิกหัวตารางเพื่อเรียงลำดับได้ (เลขที่, หัวข้อ, Category, ประเภท, ความสำคัญ, สถานะ, บริษัท, ผู้รับผิดชอบ, ผู้เปิด, วันที่สร้าง, กำหนดเสร็จ)',
    ],
  },
  {
    version: '1.16.0',
    date: '2026-09-09',
    items: [
      'สร้าง Ticket: แนบไฟล์ได้ (PDF, Excel, Word, รูปภาพ ฯลฯ สูงสุด 20 MB/ไฟล์ สูงสุด 10 ไฟล์) — ทั้งในหน้าต่างสร้าง Ticket และการ์ด Attachments ในแท็บ Details',
      'Auto-Task Rules: ตั้งกฎกับหมวดหมู่ระดับใดก็ได้ (Category / Subcategory / Item) ระบบเทียบจากระดับที่เจาะจงที่สุดก่อน',
      'Auto-Task Rules: เพิ่มตัวเลือก "ทุกหมวดหมู่ (All)" — สร้าง Task อัตโนมัติกับทุก Ticket แม้ไม่ได้ระบุหมวดหมู่ (กฎเจาะจงหมวดหมู่ชนะกฎ All เสมอ)',
    ],
  },
  {
    version: '1.15.2',
    date: '2026-09-03',
    items: [
      'ผู้ใช้สิทธิ์ Viewer: เข้าสู่ระบบแล้วเข้าหน้า ServiceDesk เป็นหน้าแรก (แทน Dashboard)',
      'หน้า ServiceDesk: ผู้ใช้สิทธิ์ Viewer จะไม่เห็นแถบการ์ดสรุปสถิติ และไม่เห็นปุ่ม Export CSV',
      'หน้า ServiceDesk: นำตัวแสดงสถานะ Live/Offline ข้างปุ่ม Export CSV ออก',
    ],
  },
  {
    version: '1.15.1',
    date: '2026-09-02',
    items: [
      'หน้ารายงาน → วิเคราะห์ด้วย AI: เพิ่มช่วงเวลา "กำหนดเอง" — เลือกวันเริ่มต้น/วันสิ้นสุดได้อิสระ (กราฟจะสรุปเป็นรายวันหรือรายเดือนอัตโนมัติตามความยาวช่วง)',
      'หน้ารายงาน → วิเคราะห์ด้วย AI: ไฟล์ Word (.docx) และ PDF แนบกราฟสรุป (สร้าง vs แก้ไขได้, ตามสถานะ, ตาม Priority) ในรายงานด้วย',
    ],
  },
  {
    version: '1.15.0',
    date: '2026-09-02',
    items: [
      'หน้ารายงาน: เพิ่มแท็บ "วิเคราะห์ด้วย AI" — สรุปข้อมูล ServiceDesk (ปริมาณ ticket, สถานะ, ความสำคัญ, SLA Compliance, เวลาแก้ไขเฉลี่ย/มัธยฐาน, แนวโน้มสร้าง-vs-แก้ไข และแนวโน้มหมวดหมู่ปัญหา) แล้วให้ AI เขียนรายงานภาษาไทยพร้อมข้อเสนอแนะ เลือกช่วงได้ทั้งรายวัน / รายเดือน / รายปี',
      'หน้ารายงาน → วิเคราะห์ด้วย AI: เก็บประวัติผลวิเคราะห์ทุกครั้ง เปิดดูย้อนหลังและลบได้ (admin) พร้อมดาวน์โหลดเป็น Word (.docx) หรือ PDF',
    ],
  },
  {
    version: '1.14.1',
    date: '2026-09-01',
    items: [
      'เปลี่ยนชื่อเมนู "Zabbix AI" เป็น "Monitor AI" เพื่อไม่ผูกกับ Zabbix โดยตรง (เผื่อรองรับระบบมอนิเตอริงอื่นในอนาคต) — การตั้งค่าการเชื่อมต่อ Zabbix และสิทธิ์เมนูเดิมยังใช้ได้ตามปกติ',
    ],
  },
  {
    version: '1.14.0',
    date: '2026-09-01',
    items: [
      'Zabbix AI: เพิ่มแท็บ "ตั้งเวลา" — ตั้งให้ระบบดึงข้อมูลและให้ AI สรุปอัตโนมัติตามรอบ รายวัน/รายเดือน/รายปี (กำหนดเวลาแบบ Asia/Bangkok, วันที่ของเดือน, เดือนของปี, Host, จำนวน metric/host และผู้ให้บริการ AI) พร้อมปุ่ม "สร้างรายงานตอนนี้"',
      'Zabbix AI: เพิ่มแท็บ "ประวัติ" — เก็บผลวิเคราะห์ทุกครั้ง (ทั้งที่กดเองและอัตโนมัติ) กรองตามช่วงเวลา เปิดดูย้อนหลัง และลบได้ (admin)',
      'Zabbix AI: ดาวน์โหลดรายงานเป็น Word (.docx สร้างจากเซิร์ฟเวอร์) หรือ PDF (หน้าพิมพ์เฉพาะ → บันทึกเป็น PDF) ได้ทั้งจากผลวิเคราะห์สดและจากประวัติ',
      'Zabbix AI: เพิ่มตัวเลือก "ดึงทุก Host ที่เปิดใช้งาน" (สูงสุด 250 เครื่อง) — ดึงแบบขนานและใช้ trends เพื่อความเร็ว, ส่งข้อมูลแบบย่อ (fleet mode) ให้ AI เมื่อ Host จำนวนมากเพื่อไม่ให้เกินขีดจำกัด token',
    ],
  },
  {
    version: '1.13.0',
    date: '2026-09-01',
    items: [
      'เพิ่มเมนูใหม่ "Zabbix AI" — วิเคราะห์สุขภาพและประสิทธิภาพระบบจากข้อมูล Zabbix Server ด้วย AI เลือกช่วงเวลาได้ทั้งรายวัน / รายเดือน / รายปี',
      'ดึงข้อมูลผ่าน Zabbix API: รายวันใช้ history (ข้อมูลดิบ), รายเดือน/รายปีใช้ trends (ค่า min/avg/max รายชั่วโมง) — เลือก Host ได้สูงสุด 8 เครื่องต่อการวิเคราะห์',
      'สรุปสถิติต่อ item (min/avg/max/last), เหตุการณ์ตามระดับความรุนแรง และปัญหาที่ค้างอยู่ แสดงเป็นการ์ด/กราฟ/ตาราง พร้อมบทวิเคราะห์และข้อเสนอแนะจาก AI',
      'Admin ตั้งค่า Zabbix URL + API Token ได้ในหน้าเมนู (แยกตามบริษัท) และทดสอบการเชื่อมต่อได้ ใช้ผู้ให้บริการ AI ร่วมกับ IT Assistant',
      'ตั้งค่าการเข้าถึงเมนู "Zabbix AI" ให้ VIEWER / TECHNICIAN ได้ที่ ตั้งค่าระบบ → การเข้าถึงเมนู',
    ],
  },
  {
    version: '1.12.1',
    date: '2026-08-31',
    items: [
      'แก้ไข: บทความ Knowledge Base ที่ยกเลิกการเผยแพร่ ("เอาเผยแพร่ออก") ตอนนี้ Admin/Super Admin ยังเห็นได้ (แสดงแท็ก "ฉบับร่าง") ส่วนผู้ใช้ทั่วไปจะไม่เห็นทั้งในรายการและเมื่อเปิดผ่านลิงก์ตรง',
    ],
  },
  {
    version: '1.12.0',
    date: '2026-08-25',
    items: [
      'ServiceDesk: เพิ่ม tab "Approval" ในหน้ารายละเอียด Ticket — IT/Admin กำหนดผู้ใช้ที่ต้องเข้ามาอนุมัติคำขอได้ (เพิ่ม/ลบผู้อนุมัติได้หลายคน) แสดงสถานะการอนุมัติโดยรวมและรายบุคคล',
      'ระบบอนุมัติ: ผู้อนุมัติกด "อนุมัติ"/"ไม่อนุมัติ" (พร้อมเหตุผล) ได้โดยตรง หรือพิมพ์ใบขออนุมัติออกไปเซ็นด้วยมือแล้วเซ็นออนไลน์/อัปโหลดรูปสแกนกลับเข้าระบบได้ เหมือนระบบลายเซ็นใบงาน (Work Order)',
      'แก้ไข: ผู้ใช้สิทธิ์ Viewer ที่ถูกกำหนดเป็นผู้อนุมัติ Ticket ตอนนี้เปิดดู Ticket นั้นได้ แม้ไม่ใช่ผู้แจ้งหรือผู้รับผิดชอบ',
      'หน้าเข้าสู่ระบบ: เพิ่มไอคอนรูปตาที่ช่องรหัสผ่านสำหรับกดดูรหัสผ่านที่พิมพ์',
    ],
  },
  {
    version: '1.11.0',
    date: '2026-08-24',
    items: [
      'ServiceDesk: Viewer เห็นเฉพาะ Ticket ที่ตัวเองเปิดหรือได้รับมอบหมายเท่านั้น ทั้งในรายการ, ตัวเลขสรุป, และหน้ารายละเอียด — เข้าดู Ticket คนอื่นผ่าน URL ตรงๆ ไม่ได้อีกต่อไป',
      'สร้าง Ticket ใหม่: กำหนดบริษัทและผู้เปิด Ticket เป็นผู้ใช้ปัจจุบันให้อัตโนมัติ (Viewer แก้ไม่ได้), ตัดประเภท "Problem" ออกจากตัวเลือก, ตัดช่องผู้รับผิดชอบออก (ให้ IT มอบหมายภายหลัง)',
      'รายละเอียด Ticket รองรับการจัดรูปแบบข้อความ แทรกรูปภาพและตารางได้ ทั้งตอนสร้างและแก้ไข',
      'ServiceDesk Settings: เปลี่ยน Auto-Assignment Rules เป็นกฎ "สร้าง Task อัตโนมัติ" — เมื่อ Ticket เข้าเงื่อนไข Category ที่กำหนด ระบบจะสร้าง Task ตามชื่อที่ตั้งไว้และมอบหมาย Ticket ให้ผู้รับผิดชอบพร้อมกัน',
      'เพิ่มแถบแสดงเวลา Response SLA ("ต้องมอบหมายภายใน...") ในหน้ารายการและรายละเอียด Ticket โดยอ้างอิงค่าที่ตั้งไว้ใน SLA Policy',
      'Viewer: ไม่เห็น tab Tasks/Checklist/Work Logs/Time Analysis ในหน้ารายละเอียด Ticket และแก้ไขผู้รับผิดชอบ (Technician) ไม่ได้',
      'IT Assistant: ปรับปรุงการค้นหา Knowledge Base ให้ครอบคลุมหัวข้อที่ไม่ใช่ IT โดยตรงด้วย (เช่น ขั้นตอนบัญชี/ขาย) และเปิดสิทธิ์เมนู Knowledge Base ให้ Viewer เห็นตามค่าเริ่มต้น',
    ],
  },
  {
    version: '1.10.1',
    date: '2026-08-20',
    items: [
      'IT Assistant: จำกัดขอบเขตการตอบให้อยู่เฉพาะข้อมูลที่เปิดให้เข้าถึงได้เท่านั้น (Assets/Tickets/Knowledge Base/Dashboard) ไม่ตอบคำถามความรู้ทั่วไปที่ไม่เกี่ยวกับระบบอีกต่อไป',
    ],
  },
  {
    version: '1.10.0',
    date: '2026-08-20',
    items: [
      'IT Assistant: รองรับการเลือกผู้ให้บริการ AI ได้หลายเจ้า — Google Gemini, Anthropic Claude, OpenAI ChatGPT และ Groq — ตั้งค่า API Key แยกต่อเจ้าได้ที่ Settings → System → IT Assistant',
      'IT Assistant (หน้าแชท): เพิ่มปุ่มเลือก AI ที่จะใช้ตอบคำถามในแต่ละครั้ง พร้อมแสดงชื่อโมเดลที่ใช้งานอยู่',
      'IT Assistant: เก็บประวัติแชทไว้ในเบราว์เซอร์ ไม่หายเมื่อรีเฟรชหรือเปลี่ยนหน้า จะลบก็ต่อเมื่อกด "ล้างแชท" เท่านั้น',
      'ปรับระยะห่างเมนูด้านซ้ายให้กระชับขึ้น ลดปัญหาต้องเลื่อนดูเมนูในจอที่เตี้ย',
    ],
  },
  {
    version: '1.9.0',
    date: '2026-08-19',
    items: [
      'เพิ่มการเข้าสู่ระบบด้วย SAML SSO (Microsoft Entra ID) เป็นทางเลือกเสริมนอกเหนือจาก username/password — ตั้งค่าได้ต่อบริษัทที่ Settings → System → SAML SSO',
      'Knowledge Base: แสดงจำนวนไฟล์แนบตลอดเวลา (แม้เป็น 0) และปรับหน้าต่างดูบทความให้ส่วนหัว/ไฟล์แนบอยู่กับที่ เลื่อนได้เฉพาะส่วนเนื้อหา',
      'Knowledge Base: แก้ตัวเลขจำนวนบทความต่อหมวดหมู่ให้แสดงถูกต้องเสมอ แม้กำลังกรองดูหมวดหมู่ใดหมวดหมู่หนึ่งอยู่',
      'เพิ่มคู่มือการตั้งค่าและใช้งาน SAML SSO ในหน้า Settings → Manual',
    ],
  },
  {
    version: '1.8.1',
    date: '2026-08-14',
    items: [
      'ใบงาน (พิมพ์): จัดรูปลายเซ็นให้อยู่กึ่งกลางของแต่ละช่อง (ผู้ปฏิบัติงาน/ผู้รับมอบงาน)',
    ],
  },
  {
    version: '1.8.0',
    date: '2026-08-14',
    items: [
      'ใบงาน: เพิ่มลายเซ็นผู้ปฏิบัติงาน แยกจากลายเซ็นลูกค้า — เซ็นออนไลน์หรืออัปโหลดรูปจากกระดาษได้เหมือนกันทั้งสองฝั่ง แสดงในหน้ารายละเอียดและหน้าพิมพ์ใบงาน',
      'ใบงาน: เพิ่มช่องหมายเหตุในแต่ละรายการงาน (checklist) แก้ไขได้โดยคลิกที่ "+ เพิ่มหมายเหตุ" ใต้รายการ',
      'ใบงาน (พิมพ์): แก้บรรทัดลงนามผู้ปฏิบัติงาน/ผู้รับมอบงานให้อยู่แถวเดียวกันเสมอ ไม่ว่าฝั่งใดจะมีรูปลายเซ็นหรือไม่',
    ],
  },
  {
    version: '1.7.4',
    date: '2026-08-14',
    items: [
      'ใบงาน (พิมพ์): ย้ายช่องลงนามผู้ปฏิบัติงาน/ผู้รับมอบงานไปไว้ด้านล่างสุดของกระดาษเสมอ และจัดรูปลายเซ็นให้ชิดขวา',
    ],
  },
  {
    version: '1.7.3',
    date: '2026-08-14',
    items: [
      'ใบงาน: แก้ไขข้อความรายการงาน (checklist) ได้โดยคลิกที่รายการหรือกดไอคอนดินสอ และจัดลำดับรายการงานใหม่ได้ด้วยปุ่มเลื่อนขึ้น/ลง',
    ],
  },
  {
    version: '1.7.2',
    date: '2026-08-11',
    items: [
      'ใบงาน: เพิ่มโหมด "อัปโหลดรูปจากกระดาษ" ในช่องลายเซ็น — กรณีพิมพ์ใบงานออกไปให้ลูกค้าเซ็นด้วยมือ สามารถถ่ายรูป/สแกนช่องที่เซ็นแล้วอัปโหลดกลับเข้าใบงานเดิมได้ทีหลัง แยกจากโหมดเซ็นออนไลน์บนจอ',
    ],
  },
  {
    version: '1.7.1',
    date: '2026-08-11',
    items: [
      'ใบงาน: เพิ่มปุ่ม "พิมพ์ใบงาน" สำหรับกรณีออกไปทำงานแบบไม่ออนไลน์ — พิมพ์เป็นกระดาษพร้อม checklist และช่องเซ็นชื่อว่างให้ลูกค้าเซ็นด้วยมือ (แสดงลายเซ็นที่เซ็นออนไลน์ไว้แล้วให้อัตโนมัติถ้ามี)',
    ],
  },
  {
    version: '1.7.0',
    date: '2026-08-11',
    items: [
      'เพิ่มระบบ "ใบงาน" (Work Order) ใหม่: สร้างใบงานผูกกับลูกค้า/สถานที่/Asset พร้อมรายการงาน (checklist) ให้พนักงานหน้างานติ๊กรายการที่ทำเสร็จแบบเรียลไทม์ผ่านมือถือ/แท็บเล็ต',
      'ใบงาน: เพิ่มช่องเซ็นชื่อลูกค้าบนหน้าจอ (touch/canvas) เพื่อยืนยันรับงาน พร้อมบันทึกชื่อผู้ลงนามและเวลาที่เซ็น',
      'ใบงาน: เพิ่มส่วนแนบรูปภาพ/ไฟล์หน้างาน และปุ่มทำเครื่องหมายเสร็จงาน/ยกเลิกใบงาน',
    ],
  },
  {
    version: '1.6.2',
    date: '2026-08-10',
    items: [
      'Software License: เพิ่มช่องค้นหาในรายการ "เครื่องที่ผูกอยู่ / User ที่ผูกอยู่" (แสดงเมื่อมีมากกว่า 5 รายการ) ช่วยหารายการที่ต้องการกดยกเลิกได้ง่ายขึ้นโดยไม่ต้องเลื่อนดูทั้งหมด',
    ],
  },
  {
    version: '1.6.1',
    date: '2026-08-06',
    items: [
      'การยืม Asset: แก้ปัญหาปุ่มปิด (X) เลื่อนตามเนื้อหาในฟอร์มยืม ทำให้ต้องเลื่อนกลับขึ้นบนสุดก่อนถึงจะปิดได้ — ตอนนี้หัวข้อและปุ่มยืนยัน/ยกเลิกอยู่กับที่เสมอ เลื่อนได้เฉพาะเนื้อหาตรงกลาง',
      'การยืม Asset: เพิ่มตัวเลือก "ไม่มีใน Asset? พิมพ์ชื่อเอง" ให้พิมพ์ชื่อสิ่งของที่ยืมเองได้ สำหรับกรณียืมของที่ไม่ได้ลงทะเบียนเป็น Asset ในระบบ',
    ],
  },
  {
    version: '1.6.0',
    date: '2026-07-24',
    items: [
      'Dashboard: ย้ายส่วน "Software License ใกล้หมดอายุ" ขึ้นบนสุดของหน้า พร้อมเพิ่ม dropdown เลือกช่วงเวลา (ภายใน 60 หรือ 180 วัน ค่าเริ่มต้น 60 วัน) และแสดงจำนวนวันคงเหลือ/เกินกำหนดจริงของแต่ละรายการแทนป้าย "180 วัน" แบบตายตัว',
      'Dashboard: เพิ่มส่วน "รายการยืม Asset ที่ยังไม่คืน" แสดงรายการที่รออนุมัติ/กำลังยืม เรียงตามวันครบกำหนดคืนใกล้สุด พร้อมบอกจำนวนวันคงเหลือหรือจำนวนวันที่เกินกำหนด',
      'การยืม Asset: เปลี่ยนช่องเลือก Asset ตอนสร้างรายการยืมเป็นช่องพิมพ์ค้นหา (แทน dropdown รายการยาว)',
      'การยืม Asset: เพิ่มปุ่ม "ดูประวัติ" ต่อรายการ แสดง timeline ว่าสร้างเมื่อไหร่ อนุมัติ/ปฏิเสธเมื่อไหร่โดยใคร และรับคืนเมื่อไหร่โดยใคร',
      'การยืม Asset: เพิ่มปุ่ม "ขยายเวลา" สำหรับกรณีขอขยายเวลาคืน Asset พร้อมตรวจสอบช่วงเวลาซ้อนทับและบันทึกในประวัติว่าใครขยายจากวันไหนเป็นวันไหน',
    ],
  },
  {
    version: '1.5.0',
    date: '2026-07-22',
    items: [
      'เพิ่มระบบ Sync Backup ขึ้น OneDrive ที่ ตั้งค่าระบบ → Backup (เฉพาะ SUPER_ADMIN): เชื่อมต่อผ่าน Microsoft Graph API พร้อมตั้งเวลาอัปโหลดอัตโนมัติตามรอบที่กำหนด ทดสอบการเชื่อมต่อ, สั่ง sync ทันที และลบไฟล์ backup เก่าที่เกินจำนวนที่ตั้งไว้อัตโนมัติ',
      'เพิ่มการลากสลับลำดับรายการ (drag-and-drop) ใน MA Checklist Templates ตอนแก้ไข Template',
      'เพิ่ม favicon (💻) ให้แท็บเบราว์เซอร์ของระบบ',
    ],
  },
  {
    version: '1.4.0',
    date: '2026-07-15',
    items: [
      'Export Excel ที่หน้า Assets: เพิ่มคอลัมน์ Site และแก้ให้คอลัมน์หน่วยงานอ้างอิงจาก Site/Department master data เหมือนหน้า Assets list จริง (เดิมใช้ค่าข้อความเก่าที่อาจว่าง)',
      'Export Excel ที่หน้า Assets: ถ้าติ๊กเลือกรายการไว้ ปุ่ม Export จะส่งออกเฉพาะรายการที่เลือกเท่านั้น (ถ้าไม่เลือกเลย export ทั้งหมดตามเดิม)',
      'แก้บั๊ก: กู้คืนข้อมูล (Restore Backup) ไฟล์ที่มีขนาดใหญ่กว่า 20MB ไม่สำเร็จ เพราะ nginx จำกัดขนาดไฟล์อัปโหลดไว้ต่ำเกินไป — ปรับเป็น 500MB พร้อมขยายเวลา timeout และแก้ข้อความ error ให้แสดงสาเหตุจริงแทนข้อความทั่วไป',
      'แก้บั๊ก: "วันที่ MA ล่าสุด" ของ Asset ไม่อัปเดตเมื่อสร้าง MA โดยไม่ได้กรอก "กำหนด MA ถัดไป" และไม่ย้อนกลับเมื่อลบ MA รายการล่าสุด — ตอนนี้ sync ตามประวัติ MA จริงเสมอทั้งตอนสร้างและลบ',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-07-15',
    items: [
      'เพิ่มรายงาน MA แบบเต็มรูปแบบที่หน้ารายงาน: อัตราการมี MA (compliance), ค่าใช้จ่าย MA รวม, กลุ่มเกินกำหนด/ใกล้ครบกำหนด (7/30/90 วัน), กราฟตามหน่วยงาน/ประเภท/Vendor, แนวโน้มรายเดือน และประวัติ MA ล่าสุด พร้อม Export CSV แต่ละส่วน',
      'เพิ่มระบบสำรอง/กู้คืนข้อมูล (Backup/Restore) ที่ ตั้งค่าระบบ → Backup (เฉพาะ SUPER_ADMIN): Export ข้อมูลทั้งระบบพร้อมไฟล์แนบเป็น .zip และ Restore กลับเข้าระบบได้ โดยต้องพิมพ์ยืนยันก่อนกู้คืนเพราะจะแทนที่ข้อมูลปัจจุบันทั้งหมด',
      'ปรับชื่อแท็บในหน้าตั้งค่าระบบเป็นภาษาอังกฤษ: การเข้าถึงเมนู → Permission, ประวัติการเปลี่ยนแปลง → Changelog, คู่มือ → Manual, สำรอง/กู้คืนข้อมูล → Backup',
      'แก้บั๊ก: `GET /maintenance/:assetId` ไม่ได้กรองตามบริษัท (companyScope) ทำให้อาจดูประวัติ MA ของ Asset บริษัทอื่นได้',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-07-15',
    items: [
      'เพิ่มหน้า "ประวัติการเปลี่ยนแปลง (Changelog)" ใน ตั้งค่าระบบ ให้เห็นว่าแต่ละเวอร์ชันแก้อะไรไปบ้าง',
      'เพิ่มตัวกรองหน้า Assets: ยี่ห้อ, Vendor, สถานะ MA (มี/ยังไม่มี), สถานะใบส่งมอบ (มี/ไม่มี), สถานะประกัน (ใกล้หมด/หมดแล้ว)',
      'เพิ่มคอลัมน์ "MA" ที่หน้า Assets แสดงจำนวนครั้งที่ทำ MA และวันที่ MA ล่าสุด พร้อมเรียงลำดับได้',
      'แก้บั๊ก: สร้าง Asset ใหม่โดยไม่เลือกผู้ใช้งานแล้ว error (`Asset_userId_fkey` foreign key violated) — ตอนนี้สร้างได้ปกติ',
      'Role TECHNICIAN สามารถแก้ไข/สร้าง/ลบ Asset, MA และ Components ได้เหมือน ADMIN โดยเปิด/ปิดสิทธิ์รายบริษัทได้ที่ ตั้งค่า → การเข้าถึงเมนู → สิทธิ์การจัดการ Asset',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-07-07',
    items: [
      'เพิ่ม AI Assistant (IT Assistant) ขับเคลื่อนด้วย Google Gemini 2.5 Flash พร้อมกำหนดสิทธิ์การเข้าถึงข้อมูลตาม Role และขอบเขตข้อมูล (ทั้งหมด/เฉพาะของตัวเอง) ได้จากตั้งค่า',
      'เปลี่ยนชื่อระบบจาก IT Asset เป็น IT Management ทั้งระบบ',
      'แก้บั๊ก: อัปเดต Asset แล้วฟิลด์ที่เชื่อมโยง (ผู้ใช้งาน/Vendor) ว่างไม่ถูกล้างค่าให้เป็น null ทำให้ผูกกับข้อมูลเก่าค้างอยู่',
    ],
  },
  {
    version: '1.0.2',
    date: '2026-06-09',
    items: [
      'เพิ่มการนำเข้า Asset จาก WinAudit พร้อมเก็บไฟล์ WinAudit แนบไว้กับ Asset',
      'เพิ่มการแสดงเวอร์ชันระบบและแท็บคู่มือการใช้งานในหน้าตั้งค่า',
      'แก้บั๊กจำนวนที่นั่ง (seats) ของ Software License คำนวณผิด',
    ],
  },
]
